<div class="uploads-list-container">
  <!-- Header Card -->
  <div class="analysis-accordion">
    <p-accordion [value]="isAnalysisExpanded ? '0' : ''">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <span class="section-title">Analysis</span>
        </p-accordion-header>
        <p-accordion-content>
          <div class="stats-row">
            <div class="stat-card">
              <span class="stat-label">Total Uploads</span>
              <span class="stat-value">{{ totalCount }}</span>
            </div>
            <div class="stat-card">
              <span class="stat-label">In Progress</span>
              <span class="stat-value">{{ getActiveJobsCount() }}</span>
            </div>
            <div class="stat-card">
              <span class="stat-label">Completed</span>
              <span class="stat-value">{{ getCompletedJobsCount() }}</span>
            </div>
            <div class="stat-card">
              <span class="stat-label">Partially Completed</span>
              <span class="stat-value">{{ getPartialJobsCount() }}</span>
            </div>
            <div class="stat-card">
              <span class="stat-label">Failed</span>
              <span class="stat-value">{{ getFailedJobsCount() }}</span>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <div class="table-actions">
    <div class="table-actions-left">
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        label="Refresh"
        class="p-button-outlined refresh-btn"
        (click)="refreshList()"
        [loading]="isLoading">
      </button>
    </div>
    <div class="table-actions-right">
      <div class="pagination-buttons">
        <button type="button" class="button-prev" (click)="loadPreviousPage()" [disabled]="pageIndex <= 1">
          <i class="pi pi-chevron-left"></i>
        </button>
        <button type="button" class="button-next" (click)="loadNextPage()" [disabled]="pageIndex >= totalPages || totalPages === 0">
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
      <span class="total-text">Total: {{ totalCount }}</span>
      <button type="button" class="filter-icon-btn" (click)="openFilterSidebar()" pTooltip="Columns preference" [tooltipPosition]="'left'">
        <span class="svg-icon-wrapper" [innerHTML]="getColumnPreferenceIcon()"></span>
      </button>
    </div>
  </div>

  <div class="table-card">
    <p-table
      [value]="uploads"
      [loading]="isLoading"
      [rows]="rowsPerPage"
      [totalRecords]="totalCount"
      [lazy]="true"
      (onLazyLoad)="onPageChange($event)"
      responsiveLayout="scroll"
      styleClass="uploads-table"
      [(selection)]="selectedUploads"
      dataKey="id">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3.5rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let column of getVisibleColumns()">
            <th [style.width]="column.width" [style.text-align]="column.align || 'left'">
              {{ column.header }}
            </th>
          </ng-container>
          <th style="width: 10rem; text-align: center;">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-job let-rowIndex="rowIndex">
        <tr class="upload-row" [ngClass]="{'row-even': rowIndex % 2 === 0, 'row-odd': rowIndex % 2 !== 0}">
          <td>
            <p-tableCheckbox [value]="job"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let column of getVisibleColumns()">
            <td [ngSwitch]="column.key" [style.text-align]="column.align || 'left'">
              <span *ngSwitchCase="'sno'" class="sno-text">{{ getSerialNumber(rowIndex) }}</span>
              <span *ngSwitchCase="'segment'" class="segment-text">{{ getModuleLabel(job.module) }}</span>
              <span *ngSwitchCase="'filename'" class="filename-text">{{ job.original_file_name || '-' }}</span>
              <span *ngSwitchCase="'size'" class="size-text">{{ job.file_size_display || '-' }}</span>
              <div *ngSwitchCase="'created_date'" class="date-cell">
                <span class="date-text">{{ formatDate(job.created_at) }}</span>
                <span class="time-ago">{{ getTimeAgo(job.created_at) }}</span>
              </div>
              <span *ngSwitchCase="'mode'" class="mode-text">{{ getModeLabel(job.mode) }}</span>
              <span *ngSwitchCase="'results'" class="results-text">{{ getResultLabel(job) }}</span>
              <p-badge *ngSwitchCase="'status'"
                [value]="getStatusLabel(job.status)"
                [severity]="getStatusSeverity(job.status)">
              </p-badge>
            </td>
          </ng-container>

          <!-- Actions -->
          <td>
            <div class="actions-cell">
              <button
                pButton
                type="button"
                icon="pi pi-eye"
                class="p-button-rounded p-button-text p-button-sm action-btn"
                [disabled]="!canViewErrors(job)"
                (click)="viewErrors(job)"
                pTooltip="View details"
                [tooltipPosition]="'left'">
              </button>
              <button
                pButton
                type="button"
                icon="pi pi-refresh"
                class="p-button-rounded p-button-text p-button-sm action-btn"
                [disabled]="!canRetry(job)"
                (click)="retryUpload(job)"
                pTooltip="Retry"
                [tooltipPosition]="'left'">
              </button>
              <button
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm action-btn"
                [disabled]="!canDelete(job)"
                (click)="confirmDelete(job)"
                [pTooltip]="job.status === 'pending' ? 'Cancel upload' : 'Delete upload'"
                [tooltipPosition]="'left'">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9">
            <div class="empty-state">
              <div class="empty-icon-wrapper">
                <i class="pi pi-upload"></i>
              </div>
              <h3>No uploads yet</h3>
              <p>Your bulk upload jobs will appear here once you start uploading files.</p>
              <span class="empty-hint">
                <i class="pi pi-info-circle"></i>
                Tip: Use the bulk upload feature on list pages to import data
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog 
    [(visible)]="displayDeleteDialog" 
    [modal]="true" 
    appendTo="body"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '476px', height: '200px' }" 
    styleClass="nuvert-delete-dialog">

    <ng-template pTemplate="header">
      <div class="dialog-header">Confirm Delete</div>
    </ng-template>

    <div class="dialog-body">
      Are you sure you want to {{ deleteActionType }} this upload?
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
        <button class="btn-delete" (click)="executeDelete()">Delete</button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- View Errors Dialog -->
  <p-dialog
    [(visible)]="showErrorsDialog"
    [modal]="true"
    [style]="{width: '800px', maxHeight: '80vh'}"
    [closable]="true"
    styleClass="nuvert-error-dialog"
    (onHide)="closeErrorsDialog()">
    
    <ng-template pTemplate="header">
      <div class="dialog-header">Upload Error Details</div>
    </ng-template>

    <div *ngIf="selectedJobForErrors" class="errors-dialog-header">
      <div class="error-info-grid">
        <div class="error-info-item">
          <span class="error-info-label">File</span>
          <span class="error-info-value">{{ selectedJobForErrors.original_file_name }}</span>
        </div>
        <div class="error-info-item">
          <span class="error-info-label">Module</span>
          <span class="error-info-value">{{ getModuleLabel(selectedJobForErrors.module) }}</span>
        </div>
        <div class="error-info-item">
          <span class="error-info-label">Status</span>
          <p-badge [value]="getStatusLabel(selectedJobForErrors.status)" [severity]="getStatusSeverity(selectedJobForErrors.status)"></p-badge>
        </div>
        <div class="error-info-item">
          <span class="error-info-label">Job ID</span>
          <span class="error-info-value job-id">{{ selectedJobForErrors.id }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="isLoadingErrors" class="errors-loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p>Loading errors...</p>
    </div>

    <!-- Main Error Message (for failed jobs) -->
    <div *ngIf="!isLoadingErrors && selectedJobForErrors?.error_message" class="main-error-container">
      <div class="main-error-header">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Error Message</span>
      </div>
      <div class="main-error-content">
        {{ selectedJobForErrors?.error_message }}
      </div>
    </div>

    <!-- Row-level Validation Errors -->
    <div *ngIf="!isLoadingErrors && selectedJobErrors.length > 0" class="validation-errors-section">
      <div class="validation-errors-header">
        <i class="pi pi-list"></i>
        <span>Validation Errors ({{ selectedJobErrors.length }})</span>
      </div>
      <p-table
        [value]="selectedJobErrors"
        [paginator]="selectedJobErrors.length > 10"
        [rows]="10"
        styleClass="p-datatable-sm"
        responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 60px;">Row</th>
            <th style="width: 120px;">Column</th>
            <th style="width: 150px;">Value</th>
            <th>Error</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-error>
          <tr>
            <td>{{ error.row || '-' }}</td>
            <td>{{ error.column || '-' }}</td>
            <td class="error-value">{{ error.value || '-' }}</td>
            <td class="error-message">{{ error.message }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- No errors found message -->
    <div *ngIf="!isLoadingErrors && !selectedJobForErrors?.error_message && selectedJobErrors.length === 0" class="errors-empty">
      <i class="pi pi-info-circle" style="font-size: 2rem; color: #6b7280;"></i>
      <p>No error details available.</p>
      <p *ngIf="selectedJobForErrors?.has_error_report">You can download the error report for more details.</p>
    </div>

    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button
          class="btn-cancel"
          [disabled]="!selectedJobForErrors?.has_error_report"
          (click)="downloadErrorReport(selectedJobForErrors!)">
          <i class="pi pi-download"></i> Download Report
        </button>
        <button
          class="btn-primary"
          [disabled]="!canRetry(selectedJobForErrors!)"
          (click)="retryUpload(selectedJobForErrors!); closeErrorsDialog()">
          <i class="pi pi-refresh"></i> Retry Upload
        </button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Filter Drawer -->
  <p-drawer [(visible)]="displayFilterSidebar" position="right" [modal]="true" [dismissible]="true"
      styleClass="filter-drawer">
      <ng-template pTemplate="header">
          <div class="drawer-header">
              <span class="drawer-title">Column Preferences</span>
          </div>
      </ng-template>

      <div class="drawer-content">
          <div class="drawer-columns" cdkDropList (cdkDropListDropped)="dropColumn($event)">
              <div *ngFor="let column of getOrderedColumnsForPreference()" class="drawer-column-item" cdkDrag>
                  <p-checkbox [binary]="true" [inputId]="column.key" [ngModel]="isColumnSelected(column.key)"
                      (ngModelChange)="toggleColumnSelection(column.key, $event)">
                  </p-checkbox>
                  <label [for]="column.key" class="column-label">{{ column.header }}</label>
              </div>
          </div>
      </div>

      <ng-template pTemplate="footer">
          <div class="drawer-footer">
              <button type="button" pButton label="Clear" class="drawer-button drawer-cancel-button"
                  (click)="clearColumnSelection()"></button>
              <button type="button" pButton label="Apply" class="drawer-button drawer-apply-button"
                  (click)="applyColumnSelection()"></button>
          </div>
      </ng-template>
  </p-drawer>
</div>
